// react-bootstrap imports
import { useNavigate } from "react-router-dom"
import { Button, Spinner} from "react-bootstrap"


export function autoFillWithCache(setShowAlertNoData)
{
    const guiaDadosSalvos = localStorage.getItem("GuiaDadosSalvos")
    if (guiaDadosSalvos === undefined || guiaDadosSalvos === null || guiaDadosSalvos === false) { setShowAlertNoData(true) ; return }
    // TODO unificar essa função com a do gerarDocumento e multa. Melhorar a verificação se há dados salvos

    const inputFields = document.getElementsByTagName("input")
    const dropdownFields = document.getElementsByTagName("select")

    for (let i = 0 ; i <= inputFields.length - 1 ; i += 1)
    {
        const inputName = inputFields[i].name
        inputFields[i].value = localStorage.getItem("GuiaInput-" + inputName)
    }

    for (let i = 0 ; i <= dropdownFields.length - 1 ; i += 1)
    {
        const dpName = dropdownFields[i].name
        dropdownFields[i].value = localStorage.getItem("GuiaInput-" + dpName)
    }
}

export function saveInputInCache(setShowAlertDataSaved)
{
    const inputFields = document.getElementsByTagName("input")
    const dropdownFields = document.getElementsByTagName("select")

    localStorage.setItem("GuiaDadosSalvos", true)
    for (let i = 0 ; i <= inputFields.length - 1 ; i += 1)
    {
        const inputName = inputFields[i].name
        localStorage.setItem("GuiaInput-" + inputName, inputFields[i].value)
        // cacheInputForm[0][inputName] = inputFields[i].value
    }

    for (let i = 0 ; i <= dropdownFields.length - 1 ; i += 1)
    {
        const dpName = dropdownFields[i].name
        localStorage.setItem("GuiaInput-" + dpName, dropdownFields[i].value)
        // cacheInputForm[0][dpName] = dropdownFields[i].value
    }

    setShowAlertDataSaved(true)
}

export const LineWithText = ({ text, align, color }) =>
{
    if (text === undefined || text === null || text === "")
    {
        return <hr className="w-100 my-3"/>
    }

    const Line = () => { return <div className="flex-grow-1"><hr className="w-100 my-0"/></div> }

    if (align === undefined || align === null || align === "center")
    {
        return (
            <div className="d-flex align-items-center my-3">
                <Line />
                <p className="fw-bold fs-7 mx-2 mb-1">{text}</p>
                <Line />
            </div>
        )
    }

    return (
        <div className="d-flex align-items-center my-3">
            <p className={"fw-bold fs-7 mx-1 mb-1 " + color}>{text}</p>
            <Line />
        </div>
    )
}

export const BotaoLoading = () =>
{
    return (
        <Button variant="success" disabled>
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"  />
        </Button>
    )
}

export const AvisoGuiaExistente = ({ procData, showAvisoGuiaExistente }) =>
{
    const navigate = useNavigate()

    if (!procData) { return <></> }
    if (!showAvisoGuiaExistente) { return <></> }

    const Redirect = () => { navigate("/MinhaConta/MeusProcessos/VerProcesso", {state: {procData: procData}}) }

    return (
        <div className="d-flex flex-column px-2 pt-2 rounded-3 mb-2" style={{backgroundColor: "rgb(255, 193, 7, 0.5)"}} >
            <p>Já existe um documento deste tipo neste processo.</p>
            <p>{"Sugerimos "}<b>editar</b>{" a guia existente clicando "}<Button className="btn px-0 pt-0" variant="link" onClick={Redirect}>aqui</Button></p>
        </div>
    )
}